<div class="footer-copyright-area">
    <span class="m-0">Copyright © {{currentYear}} Drilling Management.All rights reserved. </span>
</div>
